import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import WeatherItem from '../WeatherItem/WeatherItem';
import Toast from '../Toast/Toast';
import { getDate, getTime } from '../../utils/dateUtil';
import { WEEK_KOR_STR } from '../../utils/constants';
import { buildWeatherReport } from '../../utils/weatherTransform';
import { WeatherMainContainer } from './WeatherMain.styles';

const WeatherMain = () => {
    let navigate = useNavigate();

    const [todayLb, setTodayLb] = useState('Today');
    const [tomorrowLb, setTomorrowLb] = useState('Tomorrow');
    const [toastMsg, setToastMsg] = useState(null);
    const loadingCount = useRef(0);

    const [todayArr, setTodayArr] = useState([]);
    const [tomorrowArr, setTomorrowArr] = useState([]);
    const [list, setList] = useState([]);
    const [showReportBtn, setShowReportBtn] = useState(false);
    const [replayReportBtn, setRePlayReportBtn] = useState(false);
    const weatherData = useRef([]);

    const itemLoadStart = () => {
        if (loadingCount.current === 0) setToastMsg("날씨 정보 조회 중...");
        loadingCount.current++;
    };

    const itemLoadComplete = (item) => {
        loadingCount.current--;
        if (loadingCount.current <= 0) {
            loadingCount.current = 0;
            setToastMsg(null);
        }
        weatherData.current.push(item);

        if (list && list.length > 0 && list.length * 2 === weatherData.current.length) {
            let earlyTime = "2359";
            for (let i in list) {
                if (list[i].startHour + list[i].startMinute < earlyTime) {
                    earlyTime = list[i].startHour + list[i].startMinute;
                }
            }
            if (earlyTime > getTime()) {
                setShowReportBtn(true);
            } else {
                let reportData = JSON.parse(localStorage.getItem("_mwInfo"));
                if (reportData && reportData.date === getDate()) {
                    setRePlayReportBtn(true);
                }
            }
        }
    };

    const reportClick = () => {
        let data = buildWeatherReport(weatherData.current, list);
        localStorage.setItem("_mwInfo", JSON.stringify(data));
        navigate("/weatherinfo.html");
    };

    useEffect(() => {
        window.gtag("event", "Page_예보");

        let planList = JSON.parse(localStorage.getItem("plan")) || [];

        if (planList.length === 0) {
            alert("등록된 일정이 없습니다. 일정을 등록해주세요.");
            navigate("/plan.html");
            return;
        }

        let today = [];
        let tomorrow = [];

        for (let i = 0; i < planList.length; i++) {
            let item = planList[i];
            let isNextDay = item.startHour + item.startMinute > item.destHour + item.destMinute;

            if (isNextDay || item.destHour + item.destMinute >= getTime()) {
                today.push(item);
                let now = new Date();
                let day = getDate();
                setTodayLb(WEEK_KOR_STR[now.getDay()] + "요일 " + day.substring(4, 6) + "." + day.substring(6));
            } else {
                tomorrow.push(item);
                let now = new Date();
                now.setDate(now.getDate() + 1);
                let day = getDate(1, "D");
                setTomorrowLb(WEEK_KOR_STR[now.getDay()] + "요일 " + day.substring(4, 6) + "." + day.substring(6, 8));
            }
        }

        setTodayArr(today);
        setTomorrowArr(tomorrow);
        setList(planList);
    }, []);

    return (
        <WeatherMainContainer>
            <Header />
            <label className='scdFont titleLb'>예보</label>
            {todayArr.length > 0 &&
                <div className='weaherItemBox'>
                    <div className='dayLb scdFont'>{todayLb}</div>
                    {todayArr.map((item, i) => (
                        <WeatherItem data={item} key={'weatherStart' + i}
                            onLoadStart={itemLoadStart} onLoad={itemLoadComplete} />
                    ))}
                </div>
            }
            {tomorrowArr.length > 0 &&
                <div className='weaherItemBox'>
                    <div className='dayLb'>{tomorrowLb}</div>
                    {tomorrowArr.map((item, i) => (
                        <WeatherItem data={item} key={'weatherDest' + i}
                            onLoadStart={itemLoadStart} onLoad={itemLoadComplete} />
                    ))}
                </div>
            }
            {showReportBtn &&
                <div className='reportBtn' onClick={reportClick}>
                    <span>오늘의 날씨 리포트가 도착했습니다.</span>
                </div>
            }
            {replayReportBtn &&
                <div className='reportBtn' onClick={() => navigate("/weatherinfo.html")}>
                    <span>오늘의 리포트 다시보기</span>
                </div>
            }
            <div className='copyright'>자료 출처 : Open-Meteo</div>
            <Toast message={toastMsg} />
        </WeatherMainContainer>
    );
};

export default WeatherMain;
